import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconLayerYellowSizeS from './IconLayerYellow_size_s';

const props: CreateIconArguments = {
  l: IconLayerYellowSizeS,
  m: IconLayerYellowSizeS,
  s: IconLayerYellowSizeS,
  xs: IconLayerYellowSizeS,
  name: 'IconLayerYellow',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
